// REACT
import React, {Component} from 'react';

// STYLES
import styled from 'styled-components';
import Colors from '../../shared/colors';

// GOOGLEMAPS
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps";

export default class Map extends Component {
    render() {
        const {
            t,
            lat,
            lng,
            address
        } = this.props

        const MapWithAMarker = withScriptjs(withGoogleMap(props =>
            <GoogleMap 
                defaultZoom={8}
                defaultCenter={{ lat: lat, lng: lng }}
                defaultOptions={{
                    streetViewControl: false,
                    scaleControl: false,
                    mapTypeControl: false,
                    panControl: false,
                    zoomControl: false,
                    rotateControl: false,
                    fullscreenControl: false
                  }}
                  disableDefaultUI
                >
                <Marker position={{ lat: lat, lng: lng }} />
                
            </GoogleMap>
        ));
        return (
            <MapContent>
                <MapLabel>
                    <div>{t('Morada')}</div>
                    <div>{address}</div>
                </MapLabel>
                <MapWithAMarker 
                    googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBIibzzlbdXMSZJ-e0HebMpY-T5RRrHp08&v=3.exp&libraries=geometry,drawing,places"
                    loadingElement={<div style={{height: `100%`}}/>}
                    containerElement={<div style={{height: `240px`}}/>}
                    mapElement={<div style={{height: `100%`}}/>}
                />
            </MapContent>
        )
    }
}

const MapContent = styled.div `
    width:100%;
    position:relative;
    margin-top: 40px;
    box-shadow: 0 2px 6px 0 hsla(0, 0%, 0%, 0.150);
    border-radius: 3px;

    @media screen and (max-width: 992px) {
        margin-bottom: 50px;
    } 
`
const MapLabel = styled.div `
    position:absolute;
    z-index:2;
    margin-top: 15px;
    left: 15px;
    background-color: #FFFFFF;
    box-shadow: 0 2px 6px 0 hsla(0, 0%, 0%, 0.150);
    font-size: 16px;
    padding: 8px 12px;
    min-width: 200px;

    div:first-child{
        font-family: "PT Sans";
        font-size: 16px; 
        color: ${Colors.primary};
        font-weight: 600;
        margin-bottom: 2px;
    }
    div:last-child{
        font-family: "PT Sans";
        color: hsl(0, 0%, 17%);
        font-size: 16px; 
    }

    @media screen and (max-width: 500px) {
        right: 15px;
    } 
`


// WEBPACK FOOTER //
// ./src/containers/Map/map.container.js